export default class User {
    constructor() {
        this.id;
        this.name;
        this.surname;
        this.username;
        this.email;
        this.cellNumber;
        this.idNumber;
        this.image;
        this.allProviders;
        this.allAreas;
        this.incidentSubscribed;
        this.patientAuthorizer;
        this.roleType;
        this.providerIds;
        this.areaIds;
        this.roles;
        this.accisureCommissionRate;
        this.companyId;  

    }

    set(user) {
        this.id = user.id;
        this.name = user.name;
        this.surname = user.surname;
        this.username = user.username;
        this.email = user.email;
        this.cellNumber = user.cellNumber;
        this.idNumber = user.idNumber;
        this.image = user.image;
        this.allProviders = user.allProviders;
        this.allAreas = user.allAreas;
        this.providerIds = user.providerIds;
        this.areaIds = user.areaIds;
        this.roles = user.roles;
        this.incidentSubscribed = user.incidentSubscribed;
        this.patientAuthorizer = user.patientAuthorizer;
        this.incidentAuthorizer = user.incidentAuthorizer;
        this.roleType = (this.roles && this.roles.length > 0) ? this.roles[0] : null;
        if(this.email)
        this.email = this.email.replace(/^\n|\n$/g, '');
        this.accisureCommissionRate = user.accisureCommissionRate;
        this.companyId = user.companyId;
        return this;
    }
}
